<div class="wrapper">
    <!-- Side Bar -->
    <!-- <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar> -->
    <app-appli-side-bar [sidebars]="sidebar" (focusEventIndex)="setFocusIndex($event)" (clickEventIndex)="setClickIndex($event)"></app-appli-side-bar>


    <div class="icon_box">
        <div class="top_icon"></div>
        <div class="app_name">{{ appname }}</div>

    </div>

    <!-- Remote Control -->
    <div class="remote_control"></div>

    <!-- Datetime -->
    <div class="datetime">
        {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} {{ now_date_obj.hhmm }}
    </div>

    <!-- Main Content Wrapper -->
    <div class="main_content_wrapper">
        <div class="main_content">

            <!-- Club Oriental -->
            <div *ngIf="infoIndex == 0">
                <img src="/assets/info/cluboriental.png" class="cluboriental_img" *ngIf="lang == 'jpn'">
                <img src="/assets/info/cluboriental_en.png" class="cluboriental_img" *ngIf="lang == 'eng'">
            </div>

            <!-- LINE CARD -->
            <div *ngIf="infoIndex == 1">
                <img src="/assets/info/stampcard_jp.jpg" class="cluboriental_img" *ngIf="lang == 'jpn'">
            </div>

            <!-- Web Service -->
            <div *ngIf="infoIndex == 2">
                <div class="web_service" *ngIf="lang == 'jpn'">

                    <img src="/assets/info/web_service.svg" class="web_service_img">
                    <div class="divmessage">
                        <div class="mess_title">WEB接客サービス</div>

                        <div class="mess_s">
                            <p>皆様に快適にお過ごしいただけるよう、当ホテルではWEB接客サービス</p>
                            <p>を提供しております。お手持ちのスマートフォンで先のQRコードを</p>
                            <p>読み取ってご利用ください。</p>
                        </div>

                        <ul>
                            <li>よくある質問</li>
                            <li>館内施設 / サービス</li>
                            <li>貸出し備品 / アメニティのご案内</li>
                            <li>周辺施設 / 観光 など</li>
                        </ul>
                    </div>
                </div>

                <div class="web_service" *ngIf="lang == 'eng'">

                    <img src="/assets/info/web_service.svg" class="web_service_img">
                    <div class="divmessage">
                        <div class="mess_title">Web-based customer service</div>

                        <div class="mess_s">
                            <p>For the comfort of our guests, we offer a web-based customer service.</p>
                            <p>Please use your smartphone to read the QR code on the left.</p>
                        </div>

                        <ul>
                            <li>Frequently Asked Questions</li>
                            <li>Facilities / Services</li>
                            <li>Rental Equipment and Amenities</li>
                            <li>Facilities and Sightseeing in the Area, etc.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>